<template>
  <div>

    <div v-if="categories.length == 0">
      Add some categories&nbsp;<i class="far fa-smile"></i>
    </div>
    <ul>
      <li
        v-for="(item, index) in categories"
        :key="item"
      >
        <div class="level-left">
          <a
            class="button is-white is-small"
            @click="deleteItem(index)"
          >
            <span class="icon is-small">
              <i class="fas fa-times"></i>
            </span>
          </a>
          <p>&nbsp;{{ item }}</p>
        </div>
      </li>
    </ul>
    <div class="level">
      <input
        class="input is-small"
        type="text"
        v-model="input"
        v-on:keypress.enter="addItem()"
      />
      <button
        class="button is-small"
        @click="addItem()"
      >Add</button>
    </div>

  </div>
</template>

<script>
export default {
  props: {
    categories: Array
  },

  data() {
    return {
      input: ""
    };
  },

  methods: {
    addItem() {
      if (this.input !== "") {
        this.categories.push(this.input);
        this.input = "";
      }
    },

    deleteItem(index) {
      this.categories.splice(index, 1);
    }
  }
};
</script>

<style>
</style>
